import React, { useState, useEffect } from 'react';
import { Search, FileText, CheckCircle, Clock, XCircle, AlertCircle, Mail, Phone, Calendar, User } from 'lucide-react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Layout from '../../../components/web/Layout';
import { Helmet } from 'react-helmet';
const ApplicationTrack = () => {
  const [receiptId, setReceiptId] = useState('');
  const [searchedId, setSearchedId] = useState('');
  const [showResult, setShowResult] = useState(false);



        useEffect(() => {
            AOS.init({
                duration: 600,
                once: true,
                easing: 'ease-out-cubic'
            });
        }, []);

  const dummyData = {
    'ACT001': {
      receiptId: 'ACT001',
      applicantName: 'Rajesh Kumar',
      applicationType: 'New Membership',
      submittedDate: '15 Sep 2024',
      status: 'approved',
      statusText: 'Approved',
      email: 'rajesh.kumar@example.com',
      phone: '+91 98765 43210',
      remarks: 'All documents verified. Membership card will be dispatched soon.',
      timeline: [
        { step: 'Form Submitted', date: '15 Sep 2024', completed: true },
        { step: 'Document Verification', date: '18 Sep 2024', completed: true },
        { step: 'Committee Review', date: '22 Sep 2024', completed: true },
        { step: 'Approved', date: '25 Sep 2024', completed: true }
      ]
    },
    'ACT002': {
      receiptId: 'ACT002',
      applicantName: 'Priya Sharma',
      applicationType: 'Membership Renewal',
      submittedDate: '20 Sep 2024',
      status: 'pending',
      statusText: 'Under Review',
      email: 'priya.sharma@example.com',
      phone: '+91 87654 32109',
      remarks: 'Document verification in progress. Expected completion by 5th October.',
      timeline: [
        { step: 'Form Submitted', date: '20 Sep 2024', completed: true },
        { step: 'Document Verification', date: '23 Sep 2024', completed: true },
        { step: 'Committee Review', date: 'In Progress', completed: false },
        { step: 'Final Approval', date: 'Pending', completed: false }
      ]
    },
    'ACT003': {
      receiptId: 'ACT003',
      applicantName: 'Amit Patel',
      applicationType: 'Dispute Resolution',
      submittedDate: '10 Sep 2024',
      status: 'rejected',
      statusText: 'Rejected',
      email: 'amit.patel@example.com',
      phone: '+91 76543 21098',
      remarks: 'Application rejected due to incomplete documentation. Please resubmit with required documents.',
      timeline: [
        { step: 'Form Submitted', date: '10 Sep 2024', completed: true },
        { step: 'Document Verification', date: '12 Sep 2024', completed: true },
        { step: 'Committee Review', date: '15 Sep 2024', completed: true },
        { step: 'Rejected', date: '16 Sep 2024', completed: true }
      ]
    },
    'ACT004': {
      receiptId: 'ACT004',
      applicantName: 'Sneha Reddy',
      applicationType: 'Medical Benefit',
      submittedDate: '25 Sep 2024',
      status: 'processing',
      statusText: 'Processing',
      email: 'sneha.reddy@example.com',
      phone: '+91 65432 10987',
      remarks: 'Medical documents are being reviewed by the medical committee.',
      timeline: [
        { step: 'Form Submitted', date: '25 Sep 2024', completed: true },
        { step: 'Document Verification', date: 'In Progress', completed: false },
        { step: 'Committee Review', date: 'Pending', completed: false },
        { step: 'Final Approval', date: 'Pending', completed: false }
      ]
    }
  };

  const handleSearch = () => {
    if (receiptId.trim()) {
      setSearchedId(receiptId.trim().toUpperCase());
      setShowResult(true);
    }
  };

  const currentData = dummyData[searchedId];

  const getStatusConfig = (status) => {
    switch(status) {
      case 'approved':
        return {
          icon: CheckCircle,
          color: 'from-green-500 to-emerald-600',
          bgColor: 'bg-green-50',
          textColor: 'text-green-700',
          borderColor: 'border-green-500'
        };
      case 'pending':
        return {
          icon: Clock,
          color: 'from-amber-500 to-orange-600',
          bgColor: 'bg-amber-50',
          textColor: 'text-amber-700',
          borderColor: 'border-amber-500'
        };
      case 'rejected':
        return {
          icon: XCircle,
          color: 'from-red-500 to-rose-600',
          bgColor: 'bg-red-50',
          textColor: 'text-red-700',
          borderColor: 'border-red-500'
        };
      case 'processing':
        return {
          icon: AlertCircle,
          color: 'from-blue-500 to-cyan-600',
          bgColor: 'bg-blue-50',
          textColor: 'text-blue-700',
          borderColor: 'border-blue-500'
        };
      default:
        return {
          icon: FileText,
          color: 'from-gray-500 to-gray-600',
          bgColor: 'bg-gray-50',
          textColor: 'text-gray-700',
          borderColor: 'border-gray-500'
        };
    }
  };

  return (
      <Layout>
            <Helmet>
                <title>TRACK FORM STATUS</title>
            </Helmet>
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-purple-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-500 rounded-full filter blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
        </div>
        
        <div className="relative container mx-auto px-4 py-20 text-center">
          <div data-aos="zoom-in">
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full filter blur-xl opacity-50 animate-pulse"></div>
                <div className="relative bg-white/10 backdrop-blur-lg rounded-full p-6 border-2 border-white/30">
                  <Search className="w-16 h-16 text-white" />
                </div>
              </div>
            </div>
            <h1 className="text-5xl md:text-7xl font-black mb-4 tracking-tight">
              TRACK FORM STATUS
            </h1>
            <div className="w-40 h-1.5 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 mx-auto rounded-full mb-6"></div>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light">
              Enter your membership number to check your application status
            </p>
          </div>
        </div>
      </div>

      {/* Search Form */}
      <div className="container mx-auto px-4 -mt-12 relative z-10">
        <div data-aos="fade-up">
          <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Membership Number
                </label>
                <input
                  type="text"
                  value={receiptId}
                  onChange={(e) => setReceiptId(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                  placeholder="e.g., ACT001, ACT002, ACT003, ACT004"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:outline-none transition-colors text-lg"
                />
              </div>
              <div className="flex items-end">
                <button
                  onClick={handleSearch}
                  className="w-full md:w-auto bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-8 py-3 rounded-xl font-bold text-lg hover:from-indigo-700 hover:to-purple-700 transition-all shadow-lg transform hover:scale-105 duration-300 flex items-center justify-center gap-2"
                >
                  <Search className="w-5 h-5" />
                  Track Status
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-3">
              Try: ACT001 (Approved), ACT002 (Pending), ACT003 (Rejected), ACT004 (Processing)
            </p>
          </div>
        </div>
      </div>

      {/* Results Section */}
      {showResult && (
        <div className="container mx-auto px-4 py-16">
          {currentData ? (
            <div data-aos="fade-up">
              {/* Status Header */}
              <div className={`${getStatusConfig(currentData.status).bgColor} rounded-2xl p-8 mb-6 shadow-lg border-l-8 ${getStatusConfig(currentData.status).borderColor}`}>
                <div className="flex items-center justify-between flex-wrap gap-4">
                  <div className="flex items-center gap-4">
                    <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${getStatusConfig(currentData.status).color} flex items-center justify-center shadow-lg`}>
                      {React.createElement(getStatusConfig(currentData.status).icon, { className: "w-8 h-8 text-white" })}
                    </div>
                    <div>
                      <h2 className="text-3xl font-black text-gray-900">
                        Status: {currentData.statusText}
                      </h2>
                      <p className="text-gray-600">Membership Number: {currentData.receiptId}</p>
                    </div>
                  </div>
                  <div className={`px-6 py-3 rounded-full ${getStatusConfig(currentData.status).bgColor} border-2 ${getStatusConfig(currentData.status).borderColor}`}>
                    <span className={`font-bold text-lg ${getStatusConfig(currentData.status).textColor}`}>
                      {currentData.statusText}
                    </span>
                  </div>
                </div>
              </div>

              {/* Application Details */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
                <div data-aos="fade-right" className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <User className="w-6 h-6 text-indigo-600" />
                    Applicant Details
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <p className="text-sm text-gray-500">Name</p>
                      <p className="text-lg font-semibold text-gray-900">{currentData.applicantName}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Application Type</p>
                      <p className="text-lg font-semibold text-gray-900">{currentData.applicationType}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Submitted Date</p>
                      <p className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <Calendar className="w-4 h-4 text-indigo-600" />
                        {currentData.submittedDate}
                      </p>
                    </div>
                  </div>
                </div>

                <div data-aos="fade-left" className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Mail className="w-6 h-6 text-indigo-600" />
                    Contact Information
                  </h3>
                  <div className="space-y-3">
                    <div>
                      <p className="text-sm text-gray-500">Email</p>
                      <p className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <Mail className="w-4 h-4 text-indigo-600" />
                        {currentData.email}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Phone</p>
                      <p className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <Phone className="w-4 h-4 text-indigo-600" />
                        {currentData.phone}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Remarks */}
              <div data-aos="fade-up" className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 mb-6 border border-indigo-200">
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <FileText className="w-6 h-6 text-indigo-600" />
                  Remarks
                </h3>
                <p className="text-gray-700 leading-relaxed">{currentData.remarks}</p>
              </div>

              {/* Timeline */}
              <div data-aos="fade-up" className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Application Timeline</h3>
                <div className="space-y-6">
                  {currentData.timeline.map((item, index) => (
                    <div key={index} className="flex gap-4">
                      <div className="flex flex-col items-center">
                        <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
                          item.completed 
                            ? 'bg-gradient-to-br from-green-500 to-emerald-600' 
                            : 'bg-gray-200'
                        } shadow-lg`}>
                          {item.completed ? (
                            <CheckCircle className="w-6 h-6 text-white" />
                          ) : (
                            <Clock className="w-6 h-6 text-gray-400" />
                          )}
                        </div>
                        {index < currentData.timeline.length - 1 && (
                          <div className={`w-1 h-16 ${
                            item.completed ? 'bg-green-500' : 'bg-gray-200'
                          }`}></div>
                        )}
                      </div>
                      <div className="flex-1 pb-8">
                        <h4 className={`text-lg font-bold ${
                          item.completed ? 'text-gray-900' : 'text-gray-400'
                        }`}>
                          {item.step}
                        </h4>
                        <p className={`text-sm ${
                          item.completed ? 'text-gray-600' : 'text-gray-400'
                        }`}>
                          {item.date}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div data-aos="fade-up">
              <div className="bg-red-50 border-l-8 border-red-500 rounded-2xl p-8 text-center">
                <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  No Record Found
                </h3>
                <p className="text-gray-600">
                  Membership Number "{searchedId}" not found in our system. Please check and try again.
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Help Section */}
      {!showResult && (
        <div className="container mx-auto px-4 py-16">
          <div data-aos="fade-up" className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                How to Track Your Application
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-white font-bold text-2xl">1</span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Enter Membership Number</h4>
                  <p className="text-gray-600 text-sm">Enter your application membership number in the search box</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-white font-bold text-2xl">2</span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Click Track Status</h4>
                  <p className="text-gray-600 text-sm">Click the button to search for your application</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-rose-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-white font-bold text-2xl">3</span>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">View Details</h4>
                  <p className="text-gray-600 text-sm">Check your application status and timeline</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
     
    </div>
    </Layout>
  );
};

export default ApplicationTrack;
